/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const IconSharePDF = (props) => (
    <svg version="1.1" width="14" height="20" >
      <g fill="none" fillRule="evenodd">
       <path fillRule="evenodd" stroke="none" fill={props.color} d="M 6.63,1.48 L 4.4,3.75 C 4.34,3.82 4.23,3.82 4.16,3.75 L 3.88,3.45 C 3.81,3.38 3.81,3.26 3.88,3.2 L 6.97,0.05 C 7.03,-0.02 7.14,-0.02 7.21,0.05 L 7.49,0.35 C 7.52,0.38 7.53,0.42 7.54,0.46 L 10.31,3.25 C 10.38,3.32 10.38,3.43 10.31,3.5 L 10.01,3.79 C 9.94,3.86 9.83,3.86 9.77,3.79 L 7.37,1.38 7.37,12.6 6.63,12.6 6.63,1.48 Z M 0.74,6.3 L 0.74,18.89 13.26,18.89 13.26,6.3 8.84,6.3 8.84,5.56 14,5.56 14,19.63 0,19.63 0,5.56 5.16,5.56 5.16,6.3 0.74,6.3 Z M 0.74,6.3" />
      </g>
    </svg>
);

IconSharePDF.propTypes = {
  color: PropTypes.string,
};

export default IconSharePDF;
